import React, { useEffect } from "react";
import "./index.scss";
import UserTaskCardViewSearchBar from "./user-task-card-view-search-bar";
import UserTaskCardViewDrawer from "./user-task-card-view-drawer";
import { GET_MY_TASK_LIST } from "./services/get-my-task-list";
import { actions, callOperation } from "async-ops";
import { useDispatch, useSelector } from "react-redux";
import { first, isEqual } from "lodash";
import {
  defaultMyTaskDrawerConfig,
  defaultMyTaskWidgetConfig,
  SET_MY_TASK_DRAWER_CONFIG_OPTIONS,
  SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
} from "./reducers/user-task-card-view-reducer";
import AddUserTaskPopup from "../user-task-list/add-user-task";
import { SET_USER_TASK_ATTACHED_LEVEL_ENUMS, TOGGLE_ADD_USER_TASK_POPUP } from "../user-task-list/reducers/user-task-list-reducer";
import { bindActionCreators } from "redux";
import { GET_USER_TASK_STATUS_LIST } from "../user-task-list/services/get-user-task-status-list";
import { GET_AUDITOR_LIST } from "../user-task-list/services/get-auditor-list";
import $ from "jquery";
import { GET_ATTACHMENT_LEVEL_LIST } from "../user-task-list/services/get-attachment-level-list";
import { getFormatedDate } from "./user-task-utils";
import { GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP } from "../../pages/user-management/external-users/services/get-active-external-user-list-for-user-group";
import CancelUpdatedTaskToast from "../cancel-updated-task/cancel-updated-task-toast";
import { GET_EXTERNAL_USER_GROUP_LIST } from "../../pages/user-management/external-users/services/get-external-user-group-list";
import { GET_TASK_GROUP_LIST } from "../../pages/user-management/task-groups/services/get-task-group-list";
export interface IUserTaskCardViewProps {
  widgetTitle?: string;
  myTaskWidgetId: string;
  myPastDueTaskDrawerId: string;
  myThisWeekTaskDrawerId: string;
  myUpcomingTaskDrawerId: string;
  myCompletedTaskDrawerId: string;
  timePeriodValue?: string;
  taskCategoryIdList?: any;
  taskCategoryTypeValueList?: any;
  groupByPropertyName?: any;
  isFromMyTaskDashboardWidget?: boolean;
  isFromMyTaskPage?: boolean;
  isFromMyAuditView?: boolean;
  doNotLoadDatasourcesInd?: boolean;
  refreshListHandler?: any;
  isIncludeCanceledTasks?: boolean;
  isExternalUser?:boolean;
}
export const getMyTaskDashboardWidgetIdList = () => {
  const widgetIdList = [];
  const elements = $(".ea-dashboard-widgets-container [my-task-widget-id]");
  elements.each((i) => {
    if ($(elements[i]).attr("my-task-widget-id"))
      widgetIdList.push($(elements[i]).attr("my-task-widget-id"));
  });
  return widgetIdList;
};

export const MyTaskTimePeriodEnum = Object.freeze({
  PastDue: "PD",
  ThisWeek: "TW",
  UpComing: "UP",
  Completed: "CO",
});
export const dateDifferenceExcludingWeekends = (start, end) => {
  // Copy date objects so don't modify originals
  const s = new Date(+start);
  const e = new Date(+end);

  // Set time to midday to avoid dalight saving and browser quirks
  s.setHours(12, 0, 0, 0);
  e.setHours(12, 0, 0, 0);
  // Get the difference in whole days

  var totalDays = Math.round((e.getTime() - s.getTime()) / 8.64e7);

  if (totalDays < 0) return totalDays;

  // Get the difference in whole weeks
  var wholeWeeks = (totalDays / 7) | 0;

  // Estimate business days as number of whole weeks * 5
  var days = wholeWeeks * 5;

  // If not even number of weeks, calc remaining weekend days
  if (totalDays % 7) {
    s.setDate(s.getDate() + wholeWeeks * 7);

    while (s < e) {
      s.setDate(s.getDate() + 1);

      // If day isn't a Sunday or Saturday, add to business days
      if (s.getDay() != 0 && s.getDay() != 6) {
        ++days;
      }
    }
  }
  return days;
};
export const dateDifferenceInDays = (start, end) => {
  // Copy date objects so don't modify originals
  var s = new Date(+start);
  var e = new Date(+end);

  // Set time to midday to avoid dalight saving and browser quirks
  s.setHours(12, 0, 0, 0);
  e.setHours(12, 0, 0, 0);

  // Get the difference in whole days
  var totalDays = Math.round((e.getTime() - s.getTime()) / 8.64e7);

  return totalDays;
};
export const GetDueDateContainerClass = function(dueDate, completedBy) {
  let className = "user-task-card-due-date-container ";
  let daysDiff = dateDifferenceExcludingWeekends(
    new Date(new Date().toDateString()),
    new Date(dueDate)
  );
  if (completedBy) return className + "user-task-card-completed-due-date";
  else if (daysDiff < 0) return className + "user-task-card-past-due-date";
  else if (daysDiff > 5) return className + "user-task-card-next-week-due-date";
  else if (daysDiff <= 5 && daysDiff >= 0)
    return className + "user-task-card-current-week-due-date";
};
const getDrawerTitle = (drawerType, drawerDataCount) => {
  switch (drawerType) {
    case MyTaskTimePeriodEnum.PastDue:
      return "Past Due (" + drawerDataCount + ")";
    case MyTaskTimePeriodEnum.ThisWeek:
      return "This Week (" + drawerDataCount + ")";
    case MyTaskTimePeriodEnum.UpComing:
      return "Upcoming (" + drawerDataCount + ")";
    case MyTaskTimePeriodEnum.Completed:
      return "Completed (" + drawerDataCount + ")";
  }
};
const groupByArray = function(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

const UserTaskCardView: React.FC<IUserTaskCardViewProps> = (props) => {
  let myTaskList = useSelector(
    (state) => state["myTaskReducer"].myTaskList,
    (left, right) => {
      if (isEqual(first<any>(left[props.myTaskWidgetId])?.version, first<any>(right[props.myTaskWidgetId])?.version)) {
        return true;
      }
      return false;
    }
  );

  myTaskList = myTaskList[props.myTaskWidgetId]
    ? myTaskList[props.myTaskWidgetId]
    : [];
  let myTaskMainList = useSelector(
    (state) => state["myTaskReducer"].myTaskList,
    (left, right) => {
      if (isEqual(first<any>(left[props.myTaskWidgetId])?.version, first<any>(right[props.myTaskWidgetId])?.version)) {
        return true;
      }
      return false;
    }
  );
  myTaskMainList = myTaskMainList[props.myTaskWidgetId]
    ? myTaskMainList[props.myTaskWidgetId]
    : [];
  let filteredMyTaskList = useSelector(
    (state) => state["myTaskReducer"].filteredMyTaskList,
    (left, right) => {
      if (isEqual(left[props.myTaskWidgetId], right[props.myTaskWidgetId])) {
        return true;
      }
      return false;
    }
  );
  filteredMyTaskList = filteredMyTaskList[props.myTaskWidgetId]
    ? filteredMyTaskList[props.myTaskWidgetId]
    : [];

  let myTaskWidgetConfig = useSelector(
    (state) => state["myTaskReducer"].myTaskWidgetConfig,
    (left, right) => {
      if (isEqual(left[props.myTaskWidgetId], right[props.myTaskWidgetId])) {
        return true;
      }
      return false;
    }
  );

  myTaskWidgetConfig = myTaskWidgetConfig[props.myTaskWidgetId];
  if (myTaskWidgetConfig?.filterText) {
    myTaskList = filteredMyTaskList;
  }
  if (
    !(
      myTaskWidgetConfig?.isShowCanceledStatusTypeTaskList ||
      props.isIncludeCanceledTasks
    )
  ) {
    myTaskList = myTaskList.filter(
      (x) => x.statusType?.toLowerCase() !== "canceled"
    );
  }

  if (myTaskWidgetConfig?.isGroupByApplied) {
    myTaskList = groupByArray(
      myTaskList,
      myTaskWidgetConfig?.groupByPropertyName || "myTaskGroupByAuditName"
    );
  }
  const auditGroupId = useSelector(
    (state) =>
      state["auditPropertiesReducer"].auditPropertiesData?.auditGroupId,
    isEqual
  );
  const isCompleteTaskToastVisibleForCardView = useSelector(
    (state: any) => state["myTaskReducer"].isCompleteTaskToastVisibleForCardView,
    isEqual
  );
  const myTaskRequestObject = {
    widgetTitle: props.widgetTitle,
    timePeriodValue: props.timePeriodValue,
    taskCategoryIdList: props.taskCategoryIdList,
    taskCategoryTypeValueList: props.taskCategoryTypeValueList,
    clientTodayDate: getFormatedDate(new Date()),
    myTaskWidgetId: props.myTaskWidgetId,
  };
  const dispatch = useDispatch();
  const getFilteredDataByDrawerType = function(drawerType, isGroupByApplied) {
    var filteredData = JSON.parse(JSON.stringify(myTaskList));
    var filterDataAsPerDrawerType = function(drawerDataSource) {
      var returnData = [];
      switch (drawerType) {
        case MyTaskTimePeriodEnum.PastDue:
          returnData = JSON.parse(
            JSON.stringify(
              drawerDataSource.filter(
                (x) =>
                  dateDifferenceExcludingWeekends(
                    new Date(new Date().toDateString()),
                    new Date(x.dueDate)
                  ) < 0 && !x.completedBy
              )
            )
          );
          break;
        case MyTaskTimePeriodEnum.ThisWeek:
          returnData = JSON.parse(
            JSON.stringify(
              drawerDataSource.filter(
                (x) =>
                  dateDifferenceExcludingWeekends(
                    new Date(new Date().toDateString()),
                    new Date(x.dueDate)
                  ) <= 5 &&
                  dateDifferenceExcludingWeekends(
                    new Date(new Date().toDateString()),
                    new Date(x.dueDate)
                  ) >= 0 &&
                  !x.completedBy
              )
            )
          );
          break;
        case MyTaskTimePeriodEnum.UpComing:
          returnData = JSON.parse(
            JSON.stringify(
              drawerDataSource.filter(
                (x) =>
                  dateDifferenceExcludingWeekends(
                    new Date(new Date().toDateString()),
                    new Date(x.dueDate)
                  ) > 5 && !x.completedBy
              )
            )
          );
          break;
        case MyTaskTimePeriodEnum.Completed:
          returnData = JSON.parse(
            JSON.stringify(
              drawerDataSource.filter(
                (x) => x.completedBy && x.completedByUsedId > 0
              )
            )
          );
          break;
      }
      returnData = returnData.sort(function(a, b) {
        if (new Date(a.dueDate).getTime() < new Date(b.dueDate).getTime())
          return -1;
        if (new Date(a.dueDate).getTime() > new Date(b.dueDate).getTime())
          return 1;
        return 0;
      });
      return returnData;
    };
    var totalRowCount = 0;
    if (isGroupByApplied) {
      for (var prop in filteredData) {
        filteredData[prop] = props.timePeriodValue
          ? myTaskList[prop]
          : filterDataAsPerDrawerType(myTaskList[prop]);
        totalRowCount += filteredData[prop].length;
        if (filteredData[prop].length == 0) delete filteredData[prop];
      }
    } else {
      filteredData = props.timePeriodValue
        ? filteredData
        : filterDataAsPerDrawerType(filteredData);
      totalRowCount += filteredData.length;
    }
    return { data: filteredData, count: totalRowCount };
  };
  let visibleDrawerList = [
    MyTaskTimePeriodEnum.PastDue,
    MyTaskTimePeriodEnum.ThisWeek,
    MyTaskTimePeriodEnum.UpComing,
  ];
  if(!props.isFromMyTaskPage)
    visibleDrawerList.push(MyTaskTimePeriodEnum.Completed as any)

  if (props.timePeriodValue) {
    visibleDrawerList = visibleDrawerList.filter(
      (x) => x === props.timePeriodValue
    );
  }
  var drawerData: any = [];
  const getMyTaskDrawerId = (drawerType) => {
    switch (drawerType) {
      case MyTaskTimePeriodEnum.PastDue:
        return props.myPastDueTaskDrawerId;
      case MyTaskTimePeriodEnum.ThisWeek:
        return props.myThisWeekTaskDrawerId;
      case MyTaskTimePeriodEnum.UpComing:
        return props.myUpcomingTaskDrawerId;
      case MyTaskTimePeriodEnum.Completed:
        return props.myCompletedTaskDrawerId;
    }
  };
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: actions.asyncOperationStart,
    },
    dispatch
  );
  const refreshMyTaskListData = (isRefreshAfterSave = false) => {
    const myTaskDashboardWidgetIdList = getMyTaskDashboardWidgetIdList();

    if (
      myTaskDashboardWidgetIdList &&
      myTaskDashboardWidgetIdList.length &&
      props.isFromMyTaskDashboardWidget &&
      isRefreshAfterSave
    ) {
      myTaskDashboardWidgetIdList.forEach((element) => {
        dispatch({
          type: SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
          data: {
            isRefreshMyTaskWidget: true,
            myTaskWidgetId: element,
          },
        });
      });
    }
    if (!(props.isFromMyAuditView || props.isFromMyTaskPage)) {
      asyncAction.asyncOperationStart(GET_MY_TASK_LIST, myTaskRequestObject);
      dispatch({
        type: SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
        data: {
          isRefreshMyTaskWidget: false,
          myTaskWidgetId: props.myTaskWidgetId,
        },
      });
    }
  };

  useEffect(() => {
    if (!props.doNotLoadDatasourcesInd) {
      asyncAction.asyncOperationStart(GET_USER_TASK_STATUS_LIST, {});
      asyncAction.asyncOperationStart(GET_AUDITOR_LIST, {});
      asyncAction.asyncOperationStart(GET_ACTIVE_EXTERNAL_USER_LIST_FOR_USER_GROUP, {});
      asyncAction.asyncOperationStart(GET_EXTERNAL_USER_GROUP_LIST, {});
      asyncAction.asyncOperationStart(GET_TASK_GROUP_LIST, {});
      callOperation(GET_ATTACHMENT_LEVEL_LIST).then((response) => {
        dispatch({
          type: SET_USER_TASK_ATTACHED_LEVEL_ENUMS,
          data: { attachLevelEnums: response.userTaskLevels[0] },
        });
      });
    }
  }, []);

  const refreshMyTaskView = () => {
    if (!props.isFromMyAuditView) refreshMyTaskListData();
    dispatch({
      type: SET_MY_TASK_WIDGET_CONFIG_OPTIONS,
      data: {
        myTaskWidgetId: props.myTaskWidgetId,
        ...defaultMyTaskWidgetConfig,
      },
    });
    dispatch({
      type: SET_MY_TASK_DRAWER_CONFIG_OPTIONS,
      data: {
        ...defaultMyTaskDrawerConfig,
        myTaskDrawerId: props.myPastDueTaskDrawerId,
      },
    });
    dispatch({
      type: SET_MY_TASK_DRAWER_CONFIG_OPTIONS,
      data: {
        ...defaultMyTaskDrawerConfig,
        myTaskDrawerId: props.myThisWeekTaskDrawerId,
      },
    });
    dispatch({
      type: SET_MY_TASK_DRAWER_CONFIG_OPTIONS,
      data: {
        ...defaultMyTaskDrawerConfig,
        myTaskDrawerId: props.myUpcomingTaskDrawerId,
      },
    });
    dispatch({
      type: SET_MY_TASK_DRAWER_CONFIG_OPTIONS,
      data: {
        ...defaultMyTaskDrawerConfig,
        myTaskDrawerId: props.myCompletedTaskDrawerId,
      },
    });

    setTimeout(() => {
      if (!props.isFromMyTaskDashboardWidget) {
        dispatch({
          type: SET_MY_TASK_DRAWER_CONFIG_OPTIONS,
          data: {
            isOpened: false,
            isVisible: false,
            myTaskDrawerId: props.myCompletedTaskDrawerId,
          },
        });
      }
    });
  };
  useEffect(() => {
    if (myTaskWidgetConfig?.isRefreshMyTaskWidget) {
      refreshMyTaskView();
    }
  }, [myTaskWidgetConfig?.isRefreshMyTaskWidget]);
  useEffect(() => {
    refreshMyTaskView();
  }, [props.timePeriodValue]);
  const toggleUserTaskPopup = (dispatch,isVisible, title, mode) => {
    dispatch({
      type: TOGGLE_ADD_USER_TASK_POPUP,
      data: {
        userTaskPopupMode: mode,
        userTaskPopupTitle: title,
        isAddUserTaskPopupVisible: isVisible,
      },
    });
    if (!isVisible) {
      refreshMyTaskListData(true);
    }
  };
  return (
    <div
      style={{
        padding: props.isFromMyTaskPage ? 0 : "20px",
        height: props.isFromMyTaskDashboardWidget ? "98%" : "",
      }}
      my-task-widget-id={props.myTaskWidgetId}
    >
      {props.widgetTitle && (
        <div className={"user-task-kanaban-widget-title"}>
          {props.widgetTitle}
        </div>
      )}
      <UserTaskCardViewSearchBar
        myTaskWidgetId={props.myTaskWidgetId}
        myTaskList={myTaskMainList}
        isGroupByApplied={myTaskWidgetConfig?.isGroupByApplied}
        groupByPropertyName={myTaskWidgetConfig?.groupByPropertyName}
        isFromMyTaskDashboardWidget={props.isFromMyTaskDashboardWidget}
        isFromMyTaskPage={props.isFromMyTaskPage}
        isFromMyAuditView={props.isFromMyAuditView}
      ></UserTaskCardViewSearchBar>
      <div
        className={"user-task-kanban-parent"}
        style={{ display: "flex", width: "100%", height: "100%" }}
      >
        {visibleDrawerList.map((drawerType, index) => {
          drawerData = getFilteredDataByDrawerType(
            drawerType,
            myTaskWidgetConfig?.isGroupByApplied
          );
          return (
            <UserTaskCardViewDrawer
              drawerDataCount={drawerData.count}
              drawerType={drawerType}
              kanbanDataList={drawerData.data}
              drawerTitle={getDrawerTitle(drawerType, drawerData.count)}
              totalNumberOfDrawers={visibleDrawerList.length}
              myTaskDrawerId={getMyTaskDrawerId(drawerType)}
              key={getMyTaskDrawerId(drawerType) + index}
              myTaskWidgetId={props.myTaskWidgetId}
              myTaskRequestObject={myTaskRequestObject}
              isFromMyTaskDashboardWidget={props.isFromMyTaskDashboardWidget}
              refreshListHandler={props.refreshListHandler}
              isExternalUser={props.isExternalUser}
            ></UserTaskCardViewDrawer>
          );
        })}
      </div>
      {!(props.isFromMyAuditView || props.isFromMyTaskPage) && (
        <AddUserTaskPopup
          toggleUserTaskPopup={toggleUserTaskPopup}
          auditGroupId={auditGroupId}
          isManagerView={true}
          isFromMyTaskPage={props.isFromMyTaskPage}
          isExternalUser={props.isExternalUser}
        ></AddUserTaskPopup>
      )}
        <CancelUpdatedTaskToast
          isFromMyTaskDashboardWidget={props.isFromMyTaskDashboardWidget}
          refreshListHandler={props.refreshListHandler}
          myTaskRequestObject={myTaskRequestObject}
          isVisible={isCompleteTaskToastVisibleForCardView}
        ></CancelUpdatedTaskToast>
    </div>
  );
};
export default UserTaskCardView;
